import { createContext } from "react";
const ReferenceDataContext=createContext("reference")
export default ReferenceDataContext;